import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-place-formula-snackbar',
  templateUrl: './place-formula-snackbar.component.html',
  styleUrls: ['./place-formula-snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaceFormulaSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public prompt: string) {}
}
